export const CAMPAIGNS_COLUMNS = {
	name: "name",
} as const;
